/**
 * Skeleton / Shimmer — UX §8.6. Static diagonal gradient pan, 1600ms loop.
 * Use rectangles of the size you expect — `h-4 w-3/4` for a line of text,
 * `h-12 w-12` for a thumbnail, etc.
 *
 * NEVER use spinning circles. Spinners are forbidden globally.
 */
import * as React from 'react';
import { cn } from '../../lib/cn';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional convenience: render as inline-block instead of block. */
  inline?: boolean;
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  function Skeleton({ inline = false, className, ...rest }, ref) {
    return (
      <div
        ref={ref}
        aria-hidden
        className={cn(
          'skeleton',
          inline ? 'inline-block' : 'block',
          'bg-ink-100',
          className,
        )}
        {...rest}
      />
    );
  },
);
